
import React from 'react'
import { Tabs, Pagination } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import Table from './com/table';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class sub extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabsData: [
        { key: '1', label: '全部' }
      ],
      page: 1,
      total: 0,
      pageSize: 10
    }
  }
  async componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
  }

  loadData = () => {
    const { page, pageSize } = this.state;
    const onLoadData = (res) => {
      if (res.status == 0) {
        this.setState({ data: res.results, total: res.results.length });
      } else {
        this.setState({ data: [] });
      }
    }
    WidgetAjax.ajax({ url: path + '/job/application_list', params: { page, records: pageSize }, callback: onLoadData });
  }

  onTabChange = (value) => {
    
  }

  onPageChange = async (page,pageSize) => {
   await this.setState({page,pageSize});
   this.loadData();
  }


  render() {
    const { tabsData, page, total, pageSize, data } = this.state;

    return <div className='feedback'>
      <div className='feedback_box'>
        <Tabs items={tabsData} onChange={this.onTabChange} />
      </div>
      <div className='table'>
        <Table data={data} />

        <div className="cardtable-pagination">
          <Pagination
            hideOnSinglePage={true}
            showQuickJumper
            defaultCurrent={page}
            total={total}
            pageSize={pageSize}
            pageSizeOptions={[10, 20, 50, 100]}
            onChange={this.onPageChange}
          />
        </div>
      </div>
    </div>
  }
}

export default sub;